
/* eslint-disable @typescript-eslint/no-shadow */
export namespace SurveyRuleAction {
  export enum SurveyRuleAction {
    SKIP_TO = "SKIP_TO",
    SHOW_TARGET = "SHOW_TARGET",
    HIDE_TARGET = "HIDE_TARGET",
  }

  export interface SurveyRuleActionDTO {
    case: string;
  }

  export const fromDTO = (dto: SurveyRuleActionDTO): SurveyRuleAction => {
    if (dto === undefined || dto === null) {
      throw new InvalidSurveyRuleActionError(
        `Invalid DTO ${dto} provided for SurveyRuleAction.SurveyRuleAction`
      );
    }
    switch (dto.case) {
      case "SKIP_TO":
        return SurveyRuleAction.SKIP_TO;
      case "SHOW_TARGET":
        return SurveyRuleAction.SHOW_TARGET;
      case "HIDE_TARGET":
        return SurveyRuleAction.HIDE_TARGET;
      default:
        throw new InvalidSurveyRuleActionError(
          `Case ${dto.case} is not valid case of SurveyRuleAction.SurveyRuleAction`
        );
    }
  };

  export const toDTO = (surveyRuleAction: SurveyRuleAction): SurveyRuleActionDTO => {
    const enumDTO = {
      case: SurveyRuleAction[surveyRuleAction],
    };
    return enumDTO;
  };
}

export class InvalidSurveyRuleActionError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleActionError";
  }
}
export class InvalidSurveyRuleActionSkipToError extends InvalidSurveyRuleActionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleActionSkipToError";
  }
}

export class InvalidSurveyRuleActionShowTargetError extends InvalidSurveyRuleActionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleActionShowTargetError";
  }
}

export class InvalidSurveyRuleActionHideTargetError extends InvalidSurveyRuleActionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleActionHideTargetError";
  }
}
